var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7101 8.29002C15.5223 8.10071 15.2667 7.99422 15.0001 7.99422C14.7334 7.99422 14.4778 8.10071 14.2901 8.29002L12.0001 10.59L9.71008 8.29002C9.31796 7.8979 8.68221 7.8979 8.29008 8.29002C7.89796 8.68214 7.89796 9.3179 8.29008 9.71002L10.5901 12L8.29008 14.29C8.10077 14.4778 7.99428 14.7334 7.99428 15C7.99428 15.2667 8.10077 15.5223 8.29008 15.71C8.47785 15.8993 8.73345 16.0058 9.00008 16.0058C9.26672 16.0058 9.52232 15.8993 9.71008 15.71L12.0001 13.41L14.2901 15.71C14.4778 15.8993 14.7334 16.0058 15.0001 16.0058C15.2667 16.0058 15.5223 15.8993 15.7101 15.71C15.8994 15.5223 16.0059 15.2667 16.0059 15C16.0059 14.7334 15.8994 14.4778 15.7101 14.29L13.4101 12L15.7101 9.71002C15.8994 9.52226 16.0059 9.26666 16.0059 9.00002C16.0059 8.73338 15.8994 8.47779 15.7101 8.29002ZM19.0701 4.93002C16.5593 2.33046 12.8413 1.2879 9.34501 2.20305C5.84872 3.1182 3.11827 5.84865 2.20311 9.34495C1.28796 12.8412 2.33052 16.5593 4.93008 19.07C7.44083 21.6696 11.1589 22.7121 14.6552 21.797C18.1515 20.8818 20.8819 18.1514 21.7971 14.6551C22.7122 11.1588 21.6696 7.44077 19.0701 4.93002ZM17.6601 17.66C14.963 20.3601 10.7341 20.7791 7.55961 18.6608C4.38507 16.5425 3.14888 12.4767 4.607 8.94981C6.06511 5.42291 9.81146 3.41708 13.5551 4.1589C17.2987 4.90071 19.9971 8.1836 20.0001 12C20.0073 14.1235 19.1647 16.1616 17.6601 17.66Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default ForwardRef;